/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import setupSearch from "../components/search";
import Sortable from "sortablejs";
import Rails from "@rails/ujs";
import "core-js/stable";
import GLightbox from "glightbox";
import "@nathanvda/cocoon";
import "@popperjs/core";
import { createRoot } from "react-dom/client";
import { Dropzone } from "dropzone";

Rails.start();

document.addEventListener("DOMContentLoaded", function () {
  setupSearch();
  setupResultMap();
  setupLightbox();
  setupCottagePictureSortList(document.getElementById("cottagePictureSortList"));
  setupTooltips();
  setupReact();
  setupDropzone();
});

function setupLightbox() {
  GLightbox({ selector: "*[data-gallery]", openEffect: "fade" });
}

function setupTooltips() {
  for (let triggerEl of document.querySelectorAll('[data-bs-toggle="tooltip"]')) {
    new bootstrap.Tooltip(triggerEl);
  }
}

function setupCottagePictureSortList(el) {
  if (!el) return;
  Sortable.create(el, {
    onEnd: (evt) => {
      const data = { cottage_picture: { position_position: evt.newIndex } };

      fetch(evt.item.dataset.updateUrl, {
        body: JSON.stringify(data),
        method: "PATCH",
        redirect: "manual",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        },
      });
    },
  });
}

function setupResultMap() {
  for (const wrapperElement of document.querySelectorAll(".result-map[data-markers]")) {
    const markers = JSON.parse(wrapperElement.dataset.markers);
    const svgElement = wrapperElement.querySelector("svg");

    for (const marker of markers) {
      if (marker.lv95?.e == undefined || marker.lv95?.n == undefined) continue;

      const markerEl = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      markerEl.classList.add("marker");
      markerEl.setAttribute("cx", Math.round(marker.lv95.e / 1000));
      markerEl.setAttribute("cy", 1300 - Math.round(marker.lv95.n / 1000));
      markerEl.setAttribute("r", 3);
      markerEl.dataset.bsToggle = "tooltip";
      markerEl.setAttribute("title", marker.to_s);
      markerEl.addEventListener("click", () => (window.location.href = marker.links.show));
      svgElement?.appendChild(markerEl);
    }
  }
}

window.showTab = function (id) {
  const target = document.querySelector(`.nav-tabs a[href="#${id}"]`);
  var tab = new bootstrap.Tab(target);

  tab.show();
};

function setupReact() {
  const componentsRequireContext = import.meta.glob("~/components/rails/*.{ts,tsx}", { eager: true });
  for (const element of document.querySelectorAll("[data-component]")) {
    const component = componentsRequireContext[`/components/rails/${element.dataset.component}.tsx`];
    if (!component) continue;

    const props = JSON.parse(element.dataset.props || "{}");
    createRoot(element).render(component.default({ ...props }));
  }
}

function setupDropzone() {
  for (const element of document.querySelectorAll(".dropzone")) {
    new Dropzone(element, {
      url: element.action,
      uploadMultiple: !!element.dataset.multiple,
      paramName: element.dataset.paramName,
      maxFiles: 20,
    });
  }
}
